import { LocationType } from '../types/apiGeneratedTypes';

const LOCATION_TYPE_LABELS: Record<LocationType, string> = {
  [LocationType.CLINIC]: 'Blood Clinic',
  [LocationType.ONLINE]: 'Online',
  [LocationType.TULI]: 'TULI',
  [LocationType.HISTORICRESULTS]: 'Historic Results',
  [LocationType.MEMBER_HOME]: 'Blood Home Visit',
  [LocationType.SCAN]: 'Scan',
  [LocationType.DEXA]: 'DEXA',
};

export const getLocationTypeLabel = (location: LocationType): string =>
  LOCATION_TYPE_LABELS[location] ?? location;
